<style scoped lang="scss">
.content-div {
    background-color: white;
    width: fit-content;
    padding: 2rem 5rem;
    position: relative;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    border-radius: 0.3rem;
    font-size: 1.5rem;
}

.container {
    height: 100vh;
    display: flex;
    flex-direction: column;
    overflow: hidden;
}

.page-bg {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: #f8f9fb;
    z-index: -1;
}

.main-content1 {
    flex: 1;
    overflow-y: auto;
    padding: 7rem 1.5rem 6rem 1.5rem;
}

.mx-auto {
    margin-left: auto;
    margin-right: auto;
}

.max-w-7xl {
    max-width: 80rem;
}

.items-center {
    align-items: center;
}

.justify-between {
    justify-content: space-between;
}

.gap-x-6 {
    column-gap: 1.5rem;
}

.p-6 {
    padding: 1.5rem;
}

.lg\:px-8 {
    @media (min-width: 1024px) {
        padding-left: 2rem;
        padding-right: 2rem;
    }
}

.flex {
    display: flex;
}

.lg\:flex-1 {
    @media (min-width: 1024px) {
        flex: 1 1 0%;
    }
}

.-m-1\.5 {
    margin: -0.375rem;
}

.p-1\.5 {
    padding: 0.375rem;
}

.h-8 {
    height: 2rem;
}

.w-auto {
    width: auto;
}

.hidden {
    display: none;
}

.lg\:flex {
    @media (min-width: 1024px) {
        display: flex;
    }
}

.lg\:gap-x-12 {
    @media (min-width: 1024px) {
        column-gap: 3rem;
    }
}

.text-sm {
    font-size: 0.875rem;
    line-height: 1.25rem;
}

.font-semibold {
    font-weight: 600;
}

.leading-6 {
    line-height: 1.5rem;
}

.text-gray-900 {
    color: #111827;
}

.rounded-md {
    border-radius: 0.375rem;
}

.bg-indigo-600 {
    background-color: #4f46e5;
}

.px-3 {
    padding-left: 0.75rem;
    padding-right: 0.75rem;
}

.py-2 {
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
}

.text-white {
    color: white;
}

.shadow-sm {
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
}

.hover\:bg-indigo-500:hover {
    background-color: #4338ca;
}

.focus-visible\:outline:focus-visible {
    outline: 2px solid transparent;
    outline-offset: 2px;
}

.focus-visible\:outline-2:focus-visible {
    outline-width: 2px;
}

.focus-visible\:outline-offset-2:focus-visible {
    outline-offset: 2px;
}

.focus-visible\:outline-indigo-600:focus-visible {
    outline-color: #4f46e5;
}

.lg\:hidden {
    @media (min-width: 1024px) {
        display: none;
    }
}

.-m-2\.5 {
    margin: -0.625rem;
}

.inline-flex {
    display: inline-flex;
}

.rounded-md {
    border-radius: 0.375rem;
}

.p-2\.5 {
    padding: 0.625rem;
}

.text-gray-700 {
    color: #374151;
}

.h-6 {
    height: 1.5rem;
}

.w-6 {
    width: 1.5rem;
}

.isolate {
    isolation: isolate;
}

.hero-section {
    text-align: center;
    padding: 1.5rem 0 2rem;

    h2 {
        font-size: 1.5rem;
        font-weight: 600;
        color: #1a1a2e;
        margin: 0 0 0.75rem 0;
    }

    p {
        color: #6b7280;
        font-size: 0.875rem;
        line-height: 1.6;
        max-width: 480px;
        margin: 0 auto;
    }
}

.bg-white {
    background-color: transparent;
}

.px-6 {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
}

.py-24 {
    padding-top: 6rem;
    padding-bottom: 6rem;
}

.sm\:py-32 {
    @media (min-width: 640px) {
        padding-top: 8rem;
        padding-bottom: 8rem;
    }
}

.mx-auto {
    margin-left: auto;
    margin-right: auto;
}

.max-w-2xl {
    max-width: 42rem;
}

.sm\:text-center {
    @media (min-width: 640px) {
        text-align: center;
    }
}

.text-base {
    font-size: 1rem;
    line-height: 1.5rem;
}

.text-indigo-600 {
    color: #4f46e5;
}

.mt-2 {
    margin-top: 0.5rem;
}

.text-4xl {
    font-size: 2.25rem;
    line-height: 2.5rem;
}

.font-bold {
    font-weight: 700;
}

.tracking-tight {
    letter-spacing: -0.025em;
}

.sm\:text-6xl {
    @media (min-width: 640px) {
        font-size: 3.75rem;
        line-height: 1;
    }
}

.mt-6 {
    margin-top: 1.5rem;
}

.text-lg {
    font-size: 1.125rem;
    line-height: 1.75rem;
}

.leading-8 {
    line-height: 2rem;
}

.text-gray-600 {
    color: #4b5563;
}

.absolute {
    position: absolute;
}

.inset-x-0 {
    left: 0;
    right: 0;
}

.-top-3 {
    top: -0.75rem;
}

.-z-10 {
    z-index: -10;
}

.transform-gpu {
    transform: translateZ(0);
}

.overflow-hidden {
    overflow: hidden;
}

.px-36 {
    padding-left: 9rem;
    padding-right: 9rem;
}

.blur-3xl {
    filter: blur(64px);
}

.aspect-\[1155\/678\] {
    aspect-ratio: 1155/678;
}

.w-\[72\.1875rem\] {
    width: 72.1875rem;
}

.bg-gradient-to-tr {
    background-image: linear-gradient(to top right, var(--tw-gradient-stops));
}

.from-\[#ff80b5\] {
    --tw-gradient-from: #ff80b5;
    --tw-gradient-to: rgba(255, 128, 181, 0);
    --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}


.opacity-30 {
    opacity: 0.3;
}

.mt-10 {
    margin-top: 2.5rem;
}

.grid {
    display: grid;
    gap: 1rem;
    grid-template-columns: repeat(3, 1fr);
    /* 默认3列 */
}

@media (min-width: 1024px) {
    .grid {
        grid-template-columns: repeat(5, 1fr);
        /* 大屏幕5列 */
        gap: 1.5rem;
    }
}

@media (max-width: 640px) {
    .grid {
        grid-template-columns: repeat(2, 1fr);
        /* 手机端2列 */
        gap: 0.75rem;
    }

    .product-info {
        padding: 0.75rem;

        .product-name {
            font-size: 0.8125rem;
        }

        .product-price {
            font-size: 0.875rem;
        }

        .product-tags {
            .tag {
                font-size: 0.6875rem;
                padding: 0.125rem 0.375rem;
            }
        }

        .product-desc {
            font-size: 0.6875rem;
            -webkit-line-clamp: 1;
        }

        .download-btn {
            padding: 0.25rem 0.5rem;
            font-size: 0.6875rem;
        }
    }
}

.gap-x-8 {
    column-gap: 1rem;
}

.gap-y-8 {
    row-gap: 0rem;
}

.sm\:grid-cols-2 {
    @media (min-width: 640px) {
        grid-template-columns: repeat(2, minmax(0, 1fr));
    }
}

.sm\:gap-y-10 {
    @media (min-width: 640px) {
        row-gap: 2.5rem;
    }
}

.lg\:grid-cols-5 {
    @media (min-width: 1024px) {
        grid-template-columns: repeat(5, minmax(0, 1fr));
    }
}

.group {
    position: relative;
}

.aspect-h-3 {
    aspect-ratio: 3/1;
}

.aspect-w-4 {
    aspect-ratio: 4/1;
}

.w-full {
    width: 100%;
}

.rounded-2xl {
    border-radius: 8px;
}

.bg-gray-100 {
    background-color: #f3f4f6;
}

.drop-shadow-lg {
    filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.08));
}

.ring-1 {
    --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
    --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
    box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow);
}

.ring-inset {
    --tw-ring-inset: inset;
}

.ring-gray-900\/10 {
    --tw-ring-color: rgba(17, 24, 39, 0.1);
}

.flex-1 {
    flex: 1 1 0%;
}

.items-end {
    align-items: flex-end;
}

.p-4 {
    padding: 1rem;
}

.opacity-0 {
    opacity: 0;
}

.group-hover\:opacity-100:hover {
    opacity: 1;
}

.bg-opacity-75 {
    background-color: rgba(255, 255, 255, 0.75);
}

.backdrop-blur {
    backdrop-filter: blur(8px);
}

.backdrop-filter {
    backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}

.mt-4 {
    margin-top: 1rem;
}

.space-x-8>*+* {
    margin-left: 2rem;
}

.text-base {
    font-size: 1rem;
    line-height: 1.5rem;
}

.absolute {
    position: absolute;
}

.inset-0 {
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
}

.aria-hidden {
    display: none;
}

.flex {
    display: flex;
}

.items-center {
    align-items: center;
}

.justify-between {
    justify-content: space-between;
}

.border-t {
    border-top-width: 1px;
}

.border-gray-200 {
    border-color: #e5e7eb;
}

.px-4 {
    padding-left: 1rem;
    padding-right: 1rem;
}

.sm\:px-0 {
    @media (min-width: 640px) {
        padding-left: 0;
        padding-right: 0;
    }
}

.my-5 {
    margin-top: 1.25rem;
    margin-bottom: 1.25rem;
}

.-mt-px {
    margin-top: -1px;
}

.w-0 {
    width: 0;
}

.flex-1 {
    flex: 1 1 0%;
}

.border-t-2 {
    border-top-width: 2px;
}

.border-transparent {
    border-color: transparent;
}

.pr-1 {
    padding-right: 0.25rem;
}

.pt-4 {
    padding-top: 1rem;
}

.text-gray-500 {
    color: #6b7280;
}

.hover\:border-gray-300:hover {
    border-color: #d1d5db;
}

.hover\:text-gray-700:hover {
    color: #374151;
}

.mr-3 {
    margin-right: 0.75rem;
}

.h-5 {
    height: 1.25rem;
}

.w-5 {
    width: 1.25rem;
}

.text-gray-400 {
    color: #9ca3af;
}

.pl-1 {
    padding-left: 0.25rem;
}

.ml-3 {
    margin-left: 0.75rem;
}

.relative {
    position: relative;
}

.py-10 {
    padding-top: 2.5rem;
    padding-bottom: 2.5rem;
}

.border-4 {
    border-width: 4px;
}

.border-white {
    border-color: white;
}

.border-t-indigo-400 {
    border-top-color: #818cf8;
}

.z-10 {
    z-index: 10;
}

.px-4 {
    padding-left: 1rem;
    padding-right: 1rem;
}

.sm\:px-6 {
    @media (min-width: 640px) {
        padding-left: 1.5rem;
        padding-right: 1.5rem;
    }
}

.lg\:px-8 {
    @media (min-width: 1024px) {
        padding-left: 2rem;
        padding-right: 2rem;
    }
}

.flex-col {
    flex-direction: column;
}

.md\:flex-row {
    @media (min-width: 768px) {
        flex-direction: row;
    }
}

.text-slate-500 {
    color: #64748b;
}

.md\:mt-0 {
    @media (min-width: 768px) {
        margin-top: 0;
    }
}

.text-center {
    text-align: center;
}

.sm\:text-right {
    @media (min-width: 640px) {
        text-align: right;
    }
}

.br {
    display: block;
    margin: 0.5rem 0;
}

.breadcrumb {
    display: none;
    /* 默认隐藏 */
}

@media (max-width: 640px) {
    .breadcrumb {
        display: block;
        /* 在手机端显示 */
        padding: 1rem;
        padding-bottom: 0;
    }
}

.mobile-menu {
    position: fixed;
    top: 6rem;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 100;
    display: none;
}

@media (max-width: 640px) {
    .mobile-menu {
        display: block;
    }

    .mobile-menu-content {
        background-color: white;
        padding: 1rem;
        animation: slideDown 0.3s ease-out;
    }

    .mobile-menu-item {
        display: block;
        padding: 1rem;
        color: #374151;
        text-decoration: none;
        border-bottom: 1px solid #e5e7eb;
        font-weight: 500;

        &:hover {
            background-color: #f3f4f6;
        }
    }

    .mobile-menu-auth {
        display: flex;
        gap: 1rem;
        padding: 1rem;
        margin-top: 1rem;
        border-top: 1px solid #e5e7eb;
    }

    .mobile-menu-login {
        flex: 1;
        text-align: center;
        padding: 0.5rem;
        background-color: #9dd4ff;
        color: white;
        text-decoration: none;
        font-weight: 500;
        border-radius: 0.375rem;
    }

    .mobile-menu-register {
        flex: 1;
        text-align: center;
        padding: 0.5rem;
        background-color: #4f46e5;
        color: white;
        text-decoration: none;
        font-weight: 500;
        border-radius: 0.375rem;

        &:hover {
            background-color: #4338ca;
        }
    }
}

@keyframes slideDown {
    from {
        transform: translateY(-100%);
    }

    to {
        transform: translateY(0);
    }
}

.login-btn {
    background-color: #4f46e5;
    color: white;
    padding: 0.5rem 1rem;
    border-radius: 0.375rem;
    text-decoration: none;
    font-size: 15px;
    font-weight: 500;
    white-space: nowrap;
}

.price-dialog {
    padding: 0.75rem;
    max-height: 70vh;
    overflow-y: auto;
}

.price-grade {
    margin-bottom: 1rem;
    border: 1px solid #e5e7eb;
    border-radius: 0.375rem;
    overflow: hidden;
}

.grade-header {
    padding: 0.5rem 0.75rem;
    background-color: #f3f4f6;
    display: flex;
    justify-content: space-between;
    align-items: center;

    &.current-grade {
        background-color: #e0e7ff;
        color: #4f46e5;
    }
}

.grade-name {
    font-weight: 600;
    font-size: 0.9rem;
}

.grade-price {
    color: #ef4444;
    font-weight: 600;
    font-size: 0.9rem;
}

.time-price-list {
    padding: 0.75rem;
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 0.5rem;
}

.time-price-item {
    text-align: center;
    padding: 0.5rem;
    background-color: #f9fafb;
    border-radius: 0.25rem;
}

.time-unit {
    display: block;
    color: #6b7280;
    font-size: 0.75rem;
    margin-bottom: 0.125rem;
}

.price {
    display: block;
    color: #ef4444;
    font-weight: 600;
    font-size: 0.9rem;
}

@media (max-width: 640px) {
    .time-price-list {
        grid-template-columns: repeat(2, 1fr);
    }

    .price-dialog {
        max-height: 70vh;
        overflow-y: auto;
        padding: 0.5rem;
    }

    .time-price-item {
        padding: 0.4rem;
    }

    .time-unit {
        font-size: 0.7rem;
    }

    .price {
        font-size: 0.8rem;
    }

    .grade-name {
        font-size: 0.85rem;
    }

    .grade-price {
        font-size: 0.8rem;
    }
}

.product-info {
    padding: 1rem;
    text-align: center;
    background: #fff;
    border: 1px solid #e5e7eb;
    border-top: none;
    border-radius: 0 0 8px 8px;

    .product-name {
        font-size: 0.875rem;
        color: #1f2937;
        margin-bottom: 0.5rem;
        font-weight: 500;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .product-price {
        color: #dc2626;
        font-weight: 600;
        font-size: 1rem;
        margin-bottom: 0.5rem;
    }

    .product-tags {
        display: flex;
        justify-content: center;
        gap: 0.375rem;
        margin-bottom: 0.625rem;

        .tag {
            padding: 0.1875rem 0.5rem;
            border-radius: 4px;
            font-size: 0.6875rem;
            font-weight: 400;

            &.whole {
                background: #eff6ff;
                color: #2563eb;
            }

            &.share {
                background: #f9fafb;
                color: #6b7280;
            }

            &.no-share {
                background: #f0fdf4;
                color: #16a34a;
            }
        }
    }

    .product-desc {
        font-size: 0.75rem;
        color: #9ca3af;
        margin-bottom: 0.75rem;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
        line-height: 1.4;
    }

    .download-btn {
        display: inline-block;
        padding: 0.375rem 1rem;
        background: #4f46e5;
        color: white;
        border-radius: 6px;
        font-size: 0.8125rem;
        font-weight: 500;
        text-decoration: none;

        &:hover {
            background: #4338ca;
        }
    }
}

.version-description {
    background-color: #f0f9ff;
    border: 1px solid #bae6fd;
    border-radius: 0.375rem;
    padding: 0.75rem;
    margin-bottom: 1rem;
    color: #0369a1;
    font-size: 0.85rem;
    line-height: 1.5;
    text-align: center;
}

.footer-notes {
    display: flex;
    justify-content: space-between;
    margin-top: 1.5rem;
    padding-top: 0.75rem;
    border-top: 1px solid #e5e7eb;
    font-size: 0.8rem;
    color: #64748b;

    .note-left {
        text-align: left;
        flex: 1;
    }

    .note-right {
        text-align: right;
        flex: 1;
    }
}

.version-tabs-container {
    margin-bottom: 1rem;
    border-bottom: 1px solid #e4e7ed;
}

:deep(.el-tabs__item) {
    font-size: 0.9rem;
    padding: 0 1rem;
}

:deep(.el-tabs__header) {
    margin-bottom: 0;
}

@media (max-width: 640px) {
    .footer-notes {
        flex-direction: column;
        gap: 0.5rem;

        .note-left,
        .note-right {
            text-align: center;
            font-size: 0.75rem;
        }
    }

    .product-info {
        padding: 0.75rem;

        .product-name {
            font-size: 0.8125rem;
        }

        .product-price {
            font-size: 0.875rem;
        }

        .product-tags {
            .tag {
                font-size: 0.6875rem;
                padding: 0.125rem 0.375rem;
            }
        }

        .product-desc {
            font-size: 0.6875rem;
            -webkit-line-clamp: 5;
        }

        .download-btn {
            padding: 0.25rem 0.5rem;
            font-size: 0.6875rem;
        }
    }

    .group {
        width: 150px;
    }

    .w-full img {
        width: 150px;
    }
}

/* 设置滚动条样式 */
::-webkit-scrollbar {
    width: 6px;
    height: 6px;
}

::-webkit-scrollbar-track {
    background: transparent;
}

::-webkit-scrollbar-thumb {
    background: rgba(156, 163, 175, 0.3);
    border-radius: 3px;
}

::-webkit-scrollbar-thumb:hover {
    background: rgba(156, 163, 175, 0.5);
}

/* 火狐浏览器滚动条样式 */
* {
    scrollbar-width: thin;
    scrollbar-color: rgba(156, 163, 175, 0.3) transparent;
}
</style>
<template>
    <div class="container" id="__nuxt">
        <div style="display: flex;flex-direction: column;height: 100%;">
            <IndexHeader />
            <div class="page-bg"></div>
            <div class="main-content1">
                <div class="hero-section">
                    <h2>晓风软件授权系统</h2>
                    <p>我们将为您打造史无前例的应用产品带您认识新时代产品的创新，用心去体验产品的创新获取产品创新带来的好感</p>
                </div>
                <div class="mx-auto max-w-7xl">
                    <div class="mt-10 grid grid-cols-1 gap-x-8 gap-y-8 sm:grid-cols-2 sm:gap-y-10 lg:grid-cols-5"
                        style="padding-bottom: 20px;">
                        <article v-for="item in includes_data" :key="item.id" class="group relative"
                            @click="getPrice(item.id)">
                            <div class="aspect-h-3 aspect-w-4 w-full rounded-2xl bg-gray-100 drop-shadow-lg">
                                <img :src="item.cover || '/logo.png'" class="w-full rounded-2xl">
                            </div>
                            <div class="product-info">
                                <p class="product-name">{{ item.platform + "--" + item.name }}</p>
                                <p class="product-price">{{ item.price ? '￥' + item.price : '' }}</p>
                                <div class="product-tags">
                                    <span v-if="item.is_Whole" class="tag whole">泛域名</span>
                                    <span v-if="item.is_Share" class="tag share">通用插件</span>
                                    <span v-else class="tag no-share">独立插件</span>
                                </div>
                                <p class="product-desc" :title="item.include_desc || '暂无描述'">{{ item.include_desc ||
                                    '暂无描述' }}</p>
                                <a v-if="item.download_url" :href="item.download_url" class="download-btn"
                                    @click.stop>下载</a>
                            </div>
                        </article>
                    </div>
                    <nav class="flex items-center justify-between border-t border-gray-200 px-4 sm:px-0 my-5"
                        style="display: none;">
                        <div class="-mt-px flex w-0 flex-1"><a href="javascript:;"
                                class="inline-flex items-center border-t-2 border-transparent pr-1 pt-4 text-sm font-medium text-gray-500 hover:border-gray-300 hover:text-gray-700"><svg
                                    xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"
                                    aria-hidden="true" class="mr-3 h-5 w-5 text-gray-400">
                                    <path fill-rule="evenodd"
                                        d="M18 10a.75.75 0 01-.75.75H4.66l2.1 1.95a.75.75 0 11-1.02 1.1l-3.5-3.25a.75.75 0 010-1.1l3.5-3.25a.75.75 0 111.02 1.1l-2.1 1.95h12.59A.75.75 0 0118 10z"
                                        clip-rule="evenodd"></path>
                                </svg> 上一页 </a></div>
                        <div class="-mt-px flex w-0 flex-1 justify-end"><a href="javascript:;"
                                class="inline-flex items-center border-t-2 border-transparent pl-1 pt-4 text-sm font-medium text-gray-500 hover:border-gray-300 hover:text-gray-700">
                                下一页 <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"
                                    aria-hidden="true" class="ml-3 h-5 w-5 text-gray-400">
                                    <path fill-rule="evenodd"
                                        d="M2 10a.75.75 0 01.75-.75h12.59l-2.1-1.95a.75.75 0 111.02-1.1l3.5 3.25a.75.75 0 010 1.1l-3.5 3.25a.75.75 0 11-1.02-1.1l2.1-1.95H2.75A.75.75 0 012 10z"
                                        clip-rule="evenodd"></path>
                                </svg></a></div>
                    </nav>
                </div>
            </div>
        </div>
        <IndexFooter />
    </div>

    <!-- 价格弹窗 -->
    <el-dialog v-model="centerDialog.isShow" title="价格详情" :close-on-click-modal="true" width="90%" center>
        <div class="price-dialog">
            <!-- Version Tabs -->
            <div style="margin-bottom: 20px; border-bottom: 1px solid #e4e7ed;">
                <el-tabs v-model="active_version">
                    <el-tab-pane v-for="(version_data, version_key) in price_meal" :key="version_key"
                        :label="version_data.name" :name="parseInt(version_key)">
                    </el-tab-pane>
                </el-tabs>
            </div>

            <!-- Version Description -->
            <div v-if="price_meal[active_version] && price_meal[active_version].desc" class="version-description">
                {{ price_meal[active_version].desc }}
            </div>
            <!-- Price Grades for Active Version -->
            <div v-for="(item, index) in (price_meal[active_version] ? price_meal[active_version].meals : [])"
                :key="index" class="price-grade">
                <div class="grade-header" :class="{ 'current-grade': current_grade === item.grade_conf.grade }">
                    <span class="grade-name">{{ item.grade_conf.grade_name }}</span>
                    <span v-if="item.grade_conf.price" class="grade-price">
                        <span v-if="item.grade_conf.includes_id == -1"
                            style="color: #64748b;font-weight: none;">成为《通用插件{{
                                item.grade_conf.grade_name }}》需花费</span>
                        <span v-else style="color: #64748b;font-weight: none;">成为该插件《{{ item.grade_conf.grade_name
                            }}》需花费</span>
                        ￥{{ item.grade_conf.price }}</span>
                </div>
                <div class="time-price-list">
                    <div v-for="(price, pIndex) in item.time_price" :key="pIndex" class="time-price-item">
                        <span class="time-unit">{{ price.time_unit }}</span>
                        <span class="price">￥{{ price.price }}</span>
                    </div>
                </div>
            </div>
            <div class="footer-notes">
                <div class="note-left">需要升级代理，或者购买授权，请联系您的上级</div>
                <div class="note-right">如果有人低价授权，请向我举报，举报有奖</div>
            </div>
        </div>
    </el-dialog>
</template>
<script>
import { defineComponent } from 'vue';
import axios from 'axios';
import { ElMessage, ElNotification } from 'element-plus'
import { getIncludesList } from '@/utils/publicMethods'
import { openLoading, fullscreenLoading } from '@/utils/loadingUtils'
import IndexHeader from '@/components/IndexHeader.vue'
import IndexFooter from '@/components/IndexFooter.vue'

const baseURL = process.env.VUE_APP_API_BASE_URL;

export default defineComponent({
    name: 'IndexView',
    components: {
        IndexHeader,
        IndexFooter
    },
    data() {
        return {
            includes_data: [],
            isMobileMenuOpen: false,
            current_grade: 0,
            price_meal: [],
            active_version: 0,
            centerDialog: {
                isShow: false,
            }
        }
    },
    computed: {
    },
    methods: {
        async getIncludes() {
            const res_data = await getIncludesList(999, 1);
            if (res_data.code != 0) {
                ElMessage.error(res_data.msg)
                return
            }
            this.includes_data = res_data.data
        },
        toggleMobileMenu() {
            this.isMobileMenuOpen = !this.isMobileMenuOpen;
        }, getPrice(id) {
            openLoading()
            const headers = {
                'token': localStorage.getItem("token")
            }
            var data = new FormData()
            data.append("includes_id", id.toString())
            axios.post(baseURL + "/userApi/getGradeTimeMeal", data, { timeout: 5000, headers: headers })
                .then(res => {
                    fullscreenLoading.close()
                    if (res.data.code == 200) {
                        // Handle the new response format
                        const versions_data = res.data.data.data;

                        // Reset price_meal object
                        this.price_meal = {}
                        this.active_version = 0

                        // Process each version
                        versions_data.forEach((version_item, index) => {
                            const version_name = version_item.version_name || `版本 ${index + 1}`;
                            const version_key = index;

                            // Store data for this version
                            this.price_meal[version_key] = {
                                name: version_name,
                                desc: version_item.version_desc,
                                meals: []
                            };

                            // Process grade_arr for this version
                            version_item.grade_arr.forEach(grade_item => {
                                this.price_meal[version_key].meals.push({
                                    grade_conf: grade_item.grade_conf,
                                    time_price: grade_item.time_price.slice().sort(function (a, b) {
                                        return a.meal_id - b.meal_id;
                                    }),
                                })
                            });

                            // Sort meals by grade
                            this.price_meal[version_key].meals.sort(function (a, b) {
                                return a.grade_conf.grade - b.grade_conf.grade;
                            });
                        });

                        if (!res.data.data.current_grade) {
                            this.current_grade = 0;
                        } else {
                            this.current_grade = parseInt(res.data.data.current_grade);
                        }

                        this.centerDialog.isShow = true
                    }
                    else {
                        ElMessage.error(res.data.msg)
                    }
                })
                .catch(err => {
                    fullscreenLoading.close()
                    console.log(err)
                    ElMessage.error('获取价格表失败：' + err.message)
                })
        }
    },
    mounted() {
        this.getIncludes()
    }
})
</script>